import gql from "graphql-tag";

export const CustomGetConversationV2Shallow = gql`
  query GetConversationV2($id: String) {
    getConversationV2(id: $id) {
      id
      name
      conversation_type
      description
      icon
      invite_approval_type
      notification_range
      is_anonymous_join
      created_at
      updated_at
    }
  }
`;
